import getValidators from './getValidators';
import processErrors from './processErrors';
import validateField from './validateField';
import validateRecord from './validateRecord';

const validate = (state, fieldChanged, cb) => {
  if (state.validationPaused) {
    state.validationBlocked = true;
    if (cb) {
      cb();
    }
    return;
  }

  const { config, fields, formState } = state;
  let fieldKeys = Object.keys(fields);

  if (
    !config.validate &&
    !fieldKeys.some((key) => getValidators(fields[key]).length)
  ) {
    if (cb) {
      cb();
    }
    return;
  }

  // pare down field keys to actually validate
  let limitedValidation = false;
  if (fieldChanged) {
    const changedField = fields[fieldChanged];
    if (changedField) {
      const { validateFields } = changedField;
      if (validateFields) {
        limitedValidation = true;
        fieldKeys = validateFields.length
          ? validateFields.concat(fieldChanged)
          : [fieldChanged];
      }
    }
  }

  let recordErrors = {};
  const fieldErrors = {};
  const promises = [
    ...validateRecord(state, (errors) => {
      recordErrors = errors || {};
    }),
    ...fieldKeys.reduce(
      (result, name) =>
        result.concat(
          validateField(state, fields[name], (error) => {
            fieldErrors[name] = error;
          })
        ),
      []
    ),
  ];

  processErrors({
    fieldErrors,
    fieldKeys,
    limitedValidation,
    recordErrors,
    state,
  });

  if (promises.length) {
    formState.validating++;
    if (cb) {
      cb();
    }

    const afterPromises = () => {
      formState.validating--;
      processErrors({
        fieldErrors,
        fieldKeys,
        limitedValidation,
        recordErrors,
        state,
      });
      if (cb) {
        cb();
      }
    };

    Promise.all(promises).then(afterPromises, afterPromises);
  } else if (cb) {
    cb();
  }
};

export default validate;
